import {Component, OnInit, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-worldpage',
  templateUrl: './worldpage.component.html',
  styleUrls: ['./worldpage.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class WorldpageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
